export const SET_IPA = "SET_IPA"

export type setIPAAction = {
	type: typeof SET_IPA,
	active: boolean
}

export type Action = setIPAAction
